import { assert, IGNORED, subTestContext, Test } from "oc-e2e-testrunner";
import {
  assertBestelllisteContains,
  assertEqualsBaugruppen,
  assertEqualsBestellliste,
  createElement,
  createStreckeWithMauerUndBreite,
  resetArrangement,
} from "./utils";
import { v2 } from "oc-threejs/short3";
import { MAuswahlwert, MObjekt } from "../../metamodell";
import { sleep } from "btg-ai-agent";

export default {
  name: "TestStückliste",
};

export const testStücklisteEinfach: Test = async () => {
  // Element 3685 (SYSTEM WPC PLATINUM XL Taupe-Grau) hat keine Artikelrelation in den Metadaten
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [2]);
  agt.update3d();
  const s = agt.segmente[0];
  const element = agt.createElementFromJson({
    füllungAuswahlwert: "SYSTEM WPC PLATINUM XL Taupe-Grau",
    abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
  });
  s.getEmpties()[0].fillWithElements(element);
  agt.update3d();
  assertEqualsBestellliste(
    [
      {
        ArtikelID: "3685",
        Anzahl: 1,
      },
      {
        ArtikelID: "2341",
        Anzahl: 2,
      },
      {
        ArtikelID: "2314",
        Anzahl: 2,
      },
      {
        ArtikelID: "1398",
        Anzahl: 1,
      },
    ],
    agt.bestellliste
  );
  assertEqualsBaugruppen(
    [
      [
        {
          ArtikelID: "3685",
          MassOrBauseitsTag: "",
          Anzahl: 1,
        },
      ],
      [
        {
          ArtikelID: "2341",
          MassOrBauseitsTag: "",
          Anzahl: 2,
        },
        {
          ArtikelID: "2314",
          MassOrBauseitsTag: "",
          Anzahl: 2,
        },
        {
          ArtikelID: "1398",
          MassOrBauseitsTag: "",
          Anzahl: 1,
        },
      ],
    ],
    agt.baugruppen
  );
};

export const testShowProfileSollNichtLichtleisteEinfügen: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  const breite = 2;
  agt.grundriss.setStandardForm("Strecke", [breite]);
  agt.update3d();
  const s = agt.segmente[0];
  const defaultElement = agt.createDefaultElement();
  s.getEmpties()[0].fillWithElements(defaultElement);
  agt.update3d();
  const element = agt.getElemente()[0];
  element.setShowProfil(true);
  agt.update3d();
  assert.equals(true, element.showProfil, "showProfil");
  assert.equals(false, element.hasLichtleisten, "hasLichtleisten");
  assert.equals("Dekor Gamma Edelstahl/flach", element.profilAuswahlwert?.Key, "profilAuswahlwert");
};

export const testStücklisteKomplex: Test = async () => {
  // Fehlende Artikelrelationen in Metadaten
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [13 - 0.08]);
  agt.update3d();
  const s = agt.segmente[0];
  agt.fillIndividuellSegmentsWithElements();
  agt.update3d();
  const elemente = agt.getElemente();
  elemente[1].höhe = 1.4;
  elemente[2].showProfil = true;
  elemente[2].profilPosition = 7;
  elemente[3].change({
    massAuswahlwert: APP.richMetadata.findAuswahlwert("Einzeltor_Easy"),
  });
  elemente[4].change({
    füllungAuswahlwert: APP.richMetadata.findAuswahlwert("Keramik Zement"),
  });
  agt.update3d();
  const pfostenToChange = s.getPfosten().slice(6, 8);
  agt.changePfosten(
    {
      pfostenartAuswahlwert: APP.richMetadata.findAuswahlwert("Steckpfosten"),
    },
    pfostenToChange
  );
  agt.changePfosten(
    {
      ummantelungAuswahlwert: APP.richMetadata.findAuswahlwert("Ummantelung_mit"),
    },
    agt.getPfosten()
  );
  assert.equals(2, pfostenToChange.length);
  assert.equals("Steckpfosten", pfostenToChange[0].pfostenartAuswahlwert?.Key);
  assert.equals("Steckpfosten", pfostenToChange[1].pfostenartAuswahlwert?.Key);
  agt.update3d();
  // Achtung! Erst nach dem 2. Update sind die UMProfile drin!
  agt.update3d();
  assertEqualsBestellliste(
    [
      {
        ArtikelID: "2143",
        Anzahl: 6,
      },
      {
        ArtikelID: "2914",
        Anzahl: 1,
      },
      {
        ArtikelID: "2317",
        Anzahl: 1,
      },
      {
        ArtikelID: "2324",
        Anzahl: 1,
      },
      {
        ArtikelID: "2145",
        Anzahl: 2,
      },
      {
        ArtikelID: "2341",
        Anzahl: 5,
      },
      {
        ArtikelID: "2314",
        Anzahl: 5,
      },
      {
        ArtikelID: "1366",
        Anzahl: 5,
      },
      {
        ArtikelID: "2499_wpc_classic_xl",
        Anzahl: 1,
        Mass: "166 x 180 cm",
      },
      {
        ArtikelID: "2059",
        Anzahl: 1,
      },
      {
        ArtikelID: "1251",
        Anzahl: 1,
      },
      {
        ArtikelID: "2550",
        Anzahl: 1,
      },
      {
        ArtikelID: "2777",
        Anzahl: 2,
      },
      {
        ArtikelID: "1398",
        Anzahl: 1,
      },
    ],
    agt.bestellliste
  );
  assertEqualsBaugruppen(
    [
      [
        {
          ArtikelID: "2143",
          MassOrBauseitsTag: "bauseits",
          Anzahl: 2,
        },
      ],
      [
        {
          ArtikelID: "2143",
          MassOrBauseitsTag: "",
          Anzahl: 1,
        },
        {
          ArtikelID: "2777",
          MassOrBauseitsTag: "",
          Anzahl: 1,
        },
        {
          ArtikelID: "2317",
          MassOrBauseitsTag: "",
          Anzahl: 1,
        },
        {
          ArtikelID: "2324",
          MassOrBauseitsTag: "",
          Anzahl: 1,
        },
      ],
      [
        {
          ArtikelID: "2143",
          MassOrBauseitsTag: "",
          Anzahl: 3,
        },
      ],
      [
        {
          ArtikelID: "2914",
          MassOrBauseitsTag: "",
          Anzahl: 1,
        },
        {
          ArtikelID: "2777",
          MassOrBauseitsTag: "",
          Anzahl: 1,
        },
      ],
      [
        {
          ArtikelID: "2341",
          MassOrBauseitsTag: "",
          Anzahl: 5,
        },
        {
          ArtikelID: "1366",
          MassOrBauseitsTag: "",
          Anzahl: 5,
        },
        {
          ArtikelID: "2314",
          MassOrBauseitsTag: "",
          Anzahl: 5,
        },
        {
          ArtikelID: "1398",
          MassOrBauseitsTag: "",
          Anzahl: 1,
        },
      ],
      [
        {
          ArtikelID: "2145",
          MassOrBauseitsTag: "",
          Anzahl: 2,
        },
        {
          ArtikelID: "1398",
          MassOrBauseitsTag: "",
          Anzahl: 1,
        },
      ],
      [
        {
          ArtikelID: "2499_wpc_classic_xl",
          MassOrBauseitsTag: "166 x 180 cm",
          Anzahl: 1,
        },
        {
          ArtikelID: "2059",
          MassOrBauseitsTag: "166 x 180 cm",
          Anzahl: 1,
        },
        {
          ArtikelID: "1251",
          MassOrBauseitsTag: "166 x 180 cm",
          Anzahl: 1,
        },
        {
          ArtikelID: "2550",
          MassOrBauseitsTag: "166 x 180 cm",
          Anzahl: 1,
        },
      ],
    ],
    agt.baugruppen
  );

  const torBestellliste = [
    {
      ArtikelID: "2499_wpc_classic_xl",
      Anzahl: 1,
      Mass: "166 x 180 cm",
    },
    {
      ArtikelID: "2059",
      Anzahl: 1,
    },
    {
      ArtikelID: "1251",
      Anzahl: 1,
    },
    {
      ArtikelID: "2550",
      Anzahl: 1,
    },
  ];
  assertEqualsBestellliste(torBestellliste, agt.getElemente().find((e) => e.isTor).bestellliste);
  assertEqualsBestellliste(
    torBestellliste,
    agt.getPfosten().find((e) => e.isTorpfosten).bestellliste
  );

  assertEqualsBestellliste(
    [
      {
        ArtikelID: "2143",
        Anzahl: 1,
      },
    ],
    agt.getElemente().find((e) => e.isElement).bestellliste
  );
};

export const testStücklisteEinzeltorSollDrückerUndProfilzylinderNurEinmalZählen: Test =
  async () => {
    // Fehlende Artikelrelationen in Metadaten
    resetArrangement();
    const agt = APP.arrangement;
    agt.grundriss.setStandardForm("Strecke", [3]);
    agt.update3d();
    const s = agt.segmente[0];
    const tor = createElement(s, {
      massAuswahlwert: APP.richMetadata.findAuswahlwert("Einzeltor_Easy"),
      size: v2(1.28, 1.8),
    });
    agt.update3d();
    // Achtung! Erst nach dem 2. Update sind die UMProfile drin!
    agt.update3d();
    assertEqualsBestellliste(
      [
        {
          ArtikelID: "2499_wpc_classic_xl",
          Anzahl: 1,
          Mass: "128 x 180 cm",
        },
        {
          ArtikelID: "2059",
          Anzahl: 1,
        },
        {
          ArtikelID: "1251",
          Anzahl: 1,
        },
        {
          ArtikelID: "2550",
          Anzahl: 1,
        },
      ],
      agt.bestellliste
    );
  };

export const testStücklisteDoppeltorSollToröffnerUndTorschließerNurEinmalZählen: Test =
  async () => {
    resetArrangement();
    const agt = APP.arrangement;
    const breite = 3;
    agt.grundriss.setStandardForm("Strecke", [breite]);
    agt.update3d();
    const s = agt.segmente[0];
    const tor = createElement(s, {
      massAuswahlwert: APP.richMetadata.findAuswahlwert("Doppeltor_Easy"),
      size: v2(2.2, 1.8),
    });
    tor.setJsonPartial({
      eAntriebAuswahlwert: "E_Antrieb_ohne",
      toröffnerAuswahlwert: "Toröffner_mit",
      torschließerAuswahlwert: "Torschließer_mit",
    });
    assert.equals("E_Antrieb_ohne", tor.eAntriebAuswahlwert?.Key);
    assert.equals("Toröffner_mit", tor.toröffnerAuswahlwert?.Key);
    assert.equals("Torschließer_mit", tor.torschließerAuswahlwert?.Key);
    agt.update3d();
    // Komisch.. auch hier braucht es ein zweites update3d(), damit der Artikel 2018
    // in der Bestellliste landet
    agt.update3d();
    assertEqualsBestellliste(
      [
        {
          ArtikelID: "2036",
          Anzahl: 1,
          Mass: "219 x 180 cm",
        },
        {
          ArtikelID: "2018",
          Anzahl: 1,
        },
        {
          ArtikelID: "4770",
          Anzahl: 1,
        },
        {
          ArtikelID: "4788",
          Anzahl: 1,
        },
        {
          ArtikelID: "1251",
          Anzahl: 1,
        },
        {
          ArtikelID: "2550",
          Anzahl: 1,
        },
      ],
      agt.bestellliste
    );
  };

export const testStücklisteOhneTorschließerUndToröffnerWennTorZwischenMauer: Test = async () => {
  // ArtikelID-Änderungen in Metadaten
  resetArrangement();
  const { agt, s } = createStreckeWithMauerUndBreite(1.21 + (1.21 - 1.17), {
    links: true,
    rechts: true,
  });
  agt.setSelectedObjects(s.empties[0]);
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("Einzeltor_Easy");
  agt.changeSelectedZaunElemente({ massAuswahlwert });
  agt.selectedObjects[0].setJsonPartial({
    toröffnerAuswahlwert: "Toröffner_mit",
    torschließerAuswahlwert: "Torschließer_mit",
  });
  agt.update3d();
  assertEqualsBestellliste(
    [
      {
        ArtikelID: "2499_wpc_classic_xl",
        Anzahl: 1,
        Mass: "120 x 180 cm",
      },
      {
        ArtikelID: "611",
        Anzahl: 1,
      },
      {
        ArtikelID: "3574",
        Anzahl: 1,
      },
      {
        ArtikelID: "1251",
        Anzahl: 1,
      },
      {
        ArtikelID: "2550",
        Anzahl: 1,
      },
    ],
    agt.bestellliste
  );
};

export const testStücklisteMaßelement: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [0.92]);
  agt.update3d();
  agt.fillIndividuellSegmentsWithElements();
  agt.update3d();
  assertEqualsBestellliste(
    [
      {
        ArtikelID: "2149",
        Anzahl: 6,
      },
      {
        ArtikelID: "2272",
        Anzahl: 1,
      },
      {
        ArtikelID: "2273",
        Anzahl: 1,
      },
      {
        ArtikelID: "2341",
        Anzahl: 2,
      },
      {
        ArtikelID: "2314",
        Anzahl: 2,
      },
      {
        ArtikelID: "1398",
        Anzahl: 1,
      },
    ],
    agt.bestellliste
  );
};

export const testStücklisteArtikelSetEinzelprofile: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [12]);
  agt.update3d();
  const s = agt.segmente[0];
  const element = agt.createElementFromJson({
    füllungAuswahlwert: "SYSTEM ALU XL Plus Vintage Oak 30 cm",
    abschlussleisteAuswahlwert: "Abschlussleisten Vintage Oak",
  });
  s.getEmpties()[0].fillWithElements(element);
  agt.update3d();
  assertEqualsBestellliste(
    [
      {
        ArtikelID: "3922",
        Anzahl: 6,
      },
      {
        ArtikelID: "2341",
        Anzahl: 7,
      },
      {
        ArtikelID: "2314",
        Anzahl: 7,
      },
      {
        ArtikelID: "1398",
        Anzahl: 1,
      },
    ],
    agt.bestellliste
  );
  assertEqualsBaugruppen(
    [
      [
        {
          ArtikelID: "3922",
          MassOrBauseitsTag: "",
          Anzahl: 6,
        },
      ],
      [
        {
          ArtikelID: "2341",
          MassOrBauseitsTag: "",
          Anzahl: 7,
        },
        {
          ArtikelID: "2314",
          MassOrBauseitsTag: "",
          Anzahl: 7,
        },
        {
          ArtikelID: "1398",
          MassOrBauseitsTag: "",
          Anzahl: 1,
        },
      ],
    ],
    agt.baugruppen
  );
};

export const testStücklisteArtikelSetEinzelprofileEinzelelement: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [2]);
  agt.update3d();
  const s = agt.segmente[0];
  const element = agt.createElementFromJson({
    füllungAuswahlwert: "SYSTEM ALU XL Plus Vintage Oak 30 cm",
    abschlussleisteAuswahlwert: "Abschlussleisten Vintage Oak",
  });
  s.getEmpties()[0].fillWithElements(element);
  agt.update3d();
  assertEqualsBestellliste(
    [
      {
        ArtikelID: "3922",
        Anzahl: 1,
      },
      {
        ArtikelID: "2341",
        Anzahl: 2,
      },
      {
        ArtikelID: "2314",
        Anzahl: 2,
      },
      {
        ArtikelID: "1398",
        Anzahl: 1,
      },
    ],
    agt.bestellliste
  );
  assertEqualsBaugruppen(
    [
      [
        {
          ArtikelID: "3922",
          MassOrBauseitsTag: "",
          Anzahl: 1,
        },
      ],
      [
        {
          ArtikelID: "2341",
          MassOrBauseitsTag: "",
          Anzahl: 2,
        },
        {
          ArtikelID: "2314",
          MassOrBauseitsTag: "",
          Anzahl: 2,
        },
        {
          ArtikelID: "1398",
          MassOrBauseitsTag: "",
          Anzahl: 1,
        },
      ],
    ],
    agt.baugruppen
  );
};

export const testStücklisteArtikelSetEinzelprofileDoppelelement: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [4]);
  agt.update3d();
  const s = agt.segmente[0];
  const element = agt.createElementFromJson({
    füllungAuswahlwert: "SYSTEM ALU XL Plus Vintage Oak 30 cm",
    abschlussleisteAuswahlwert: "Abschlussleisten Vintage Oak",
  });
  s.getEmpties()[0].fillWithElements(element);
  agt.update3d();
  assertEqualsBestellliste(
    [
      {
        ArtikelID: "3922",
        Anzahl: 2,
      },
      {
        ArtikelID: "2341",
        Anzahl: 3,
      },
      {
        ArtikelID: "2314",
        Anzahl: 3,
      },
      {
        ArtikelID: "1398",
        Anzahl: 1,
      },
    ],
    agt.bestellliste
  );
  assertEqualsBaugruppen(
    [
      [
        {
          ArtikelID: "3922",
          MassOrBauseitsTag: "",
          Anzahl: 2,
        },
      ],
      [
        {
          ArtikelID: "2341",
          MassOrBauseitsTag: "",
          Anzahl: 3,
        },
        {
          ArtikelID: "2314",
          MassOrBauseitsTag: "",
          Anzahl: 3,
        },
        {
          ArtikelID: "1398",
          MassOrBauseitsTag: "",
          Anzahl: 1,
        },
      ],
    ],
    agt.baugruppen
  );
};

export const testStücklisteArtikelSetEinzelprofileMitDekorprofilen: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [12]);
  agt.update3d();
  const s = agt.segmente[0];
  const element = agt.createElementFromJson({
    füllungAuswahlwert: "SYSTEM ALU XL Plus Vintage Oak 30 cm",
    abschlussleisteAuswahlwert: "Abschlussleisten Vintage Oak",
    profilAuswahlwert: "Dekor Omega Anthrazit/hoch",
    profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
    profilPosition: 5,
    showProfil: true,
  });
  s.getEmpties()[0].fillWithElements(element);
  agt.update3d();

  // Problem: Die Zaunfeld-Sets, Dekorprofil-Sets, Dekorprofil-Adapterleisten sind zuschneidbar
  // 1) Damit gelangen sie in die UNGROUPED, und haben dann keine "Bauseits"-Kennzeichnung mehr
  //    Dadurch können sie nicht als virtuelle Artikel wirken
  //    was hier fehlt ist evtl.: Kennzeichnen, dass es Bauseits Artikel sind
  //    andererseits könnte man evtl. auch schließen, dass es Bauseits Artikel sein müssen,
  //    weil in der UNGROUPED nur Bauseits Artikel sein können, wenn sich überhaupt die Frage
  //    stellt (!)

  // 2) In der UNGROUPED können potentiell mehrere Dekorprofil-Adapterleisten-Kombinationen stehen.
  //    Momentan setzen die Klammern vorraus, dass es eindeutig ist - das muss es aber nicht, weil
  //    ja das Abzählen ausreicht. --> gelöst

  assertEqualsBestellliste(
    [
      {
        ArtikelID: "3922",
        Anzahl: 5,
      },
      {
        ArtikelID: "2434",
        Anzahl: 6,
      },
      {
        ArtikelID: "2324",
        Anzahl: 6,
      },
      {
        ArtikelID: "3946",
        Anzahl: 1,
      },
      {
        ArtikelID: "3938",
        Anzahl: 1,
      },
      {
        ArtikelID: "2341",
        Anzahl: 7,
      },
      {
        ArtikelID: "2314",
        Anzahl: 7,
      },
      {
        ArtikelID: "1398",
        Anzahl: 1,
      },
    ],
    agt.bestellliste
  );
  assertEqualsBaugruppen(
    [
      [
        {
          ArtikelID: "3922",
          MassOrBauseitsTag: "",
          Anzahl: 6,
        },
        {
          ArtikelID: "2434",
          MassOrBauseitsTag: "",
          Anzahl: 6,
        },
        {
          ArtikelID: "2324",
          MassOrBauseitsTag: "",
          Anzahl: 6,
        },
      ],
      [
        {
          ArtikelID: "2341",
          MassOrBauseitsTag: "",
          Anzahl: 7,
        },
        {
          ArtikelID: "2314",
          MassOrBauseitsTag: "",
          Anzahl: 7,
        },
        {
          ArtikelID: "1398",
          MassOrBauseitsTag: "",
          Anzahl: 1,
        },
      ],
    ],
    agt.baugruppen
  );
};

export const testStücklisteKonkurrierendeArtikelsets1: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [2]);
  agt.update3d();
  const s = agt.segmente[0];
  const element = agt.createElementFromJson({
    füllungAuswahlwert: "SYSTEM WPC CLASSIC Mandel",
    abschlussleisteAuswahlwert: "Abschlussleisten Silber",
  });
  s.getEmpties()[0].fillWithElements(element);
  agt.update3d();
  assertEqualsBestellliste(
    [
      {
        ArtikelID: "2232",
        Anzahl: 1,
      },
      {
        ArtikelID: "2341",
        Anzahl: 2,
      },
      {
        ArtikelID: "2314",
        Anzahl: 2,
      },
      {
        ArtikelID: "1398",
        Anzahl: 1,
      },
    ],
    agt.bestellliste
  );
};

export const testStücklisteKonkurrierendeArtikelsets2: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [2]);
  agt.update3d();
  const s = agt.segmente[0];
  const element = agt.createElementFromJson({
    füllungAuswahlwert: "SYSTEM WPC CLASSIC Mandel",
    abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
  });
  s.getEmpties()[0].fillWithElements(element);
  agt.update3d();
  assertEqualsBestellliste(
    [
      {
        ArtikelID: "2142",
        Anzahl: 1,
      },
      {
        ArtikelID: "2341",
        Anzahl: 2,
      },
      {
        ArtikelID: "2314",
        Anzahl: 2,
      },
      {
        ArtikelID: "1398",
        Anzahl: 1,
      },
    ],
    agt.bestellliste
  );
};

export const testStücklisteDekorprofiladapterBauseits: Test = async () => {
  // Fehlende Artikelrelationen für Dekor_Adapter in Metadaten
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [4]);
  agt.update3d();
  const s = agt.segmente[0];
  const element = agt.createElementFromJson({
    form: "Rechteck",
    füllungAuswahlwert: "SYSTEM WPC CLASSIC Mandel",
    abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
    profilAuswahlwert: "Dekor Puls Edelstahl/hoch",
    profilPosition: 11,
    profilleisteAuswahlwert: "Dekor_Adapter_silber",
    showProfil: true,
  });
  s.getEmpties()[0].fillWithElements(element);
  agt.update3d();
  assertEqualsBestellliste(
    [
      {
        ArtikelID: "2142",
        Anzahl: 2,
      },
      {
        ArtikelID: "3297",
        Anzahl: 2,
      },
      {
        ArtikelID: "2341",
        Anzahl: 3,
      },
      {
        ArtikelID: "2314",
        Anzahl: 3,
      },
      {
        ArtikelID: "1398",
        Anzahl: 1,
      },
    ],
    agt.bestellliste
  );
  assertEqualsBaugruppen(
    [
      [
        {
          ArtikelID: "2142",
          MassOrBauseitsTag: "",
          Anzahl: 2,
        },
        {
          ArtikelID: "3297",
          MassOrBauseitsTag: "",
          Anzahl: 2,
        },
      ],
      [
        {
          ArtikelID: "2341",
          MassOrBauseitsTag: "",
          Anzahl: 3,
        },
        {
          ArtikelID: "2314",
          MassOrBauseitsTag: "",
          Anzahl: 3,
        },
        {
          ArtikelID: "1398",
          MassOrBauseitsTag: "",
          Anzahl: 1,
        },
      ],
    ],
    agt.baugruppen
  );
};

export const testStücklisteDekorprofiladapterFertigung: Test = async () => {
  // Fehlende Artikelrelationen für Dekor_Adapter in Metadaten
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [2]);
  agt.update3d();
  const s = agt.segmente[0];
  const element = agt.createElementFromJson({
    form: "Einzeltor",
    füllungAuswahlwert: "SYSTEM WPC CLASSIC Mandel",
    abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
    profilAuswahlwert: "Dekor Puls Edelstahl/hoch",
    profilPosition: 11,
    profilleisteAuswahlwert: "Dekor_Adapter_silber",
    showProfil: true,
  });
  s.getEmpties()[0].fillWithElements(element);
  agt.update3d();
  assertEqualsBestellliste(
    [
      {
        ArtikelID: "1251",
        Anzahl: 1,
      },
      {
        ArtikelID: "2059",
        Anzahl: 1,
      },
      {
        ArtikelID: "2323",
        Anzahl: 1,
      },
      {
        ArtikelID: "2499_wpc_classic_xl",
        Anzahl: 1,
        Mass: "178 x 180 cm",
      },
      {
        ArtikelID: "2550",
        Anzahl: 1,
      },
      {
        ArtikelID: "3297_preisaufschlag",
        Anzahl: 1,
      },
    ],
    agt.bestellliste
  );
  assertEqualsBaugruppen(
    [
      [
        {
          ArtikelID: "2499_wpc_classic_xl",
          MassOrBauseitsTag: "178 x 180 cm",
          Anzahl: 1,
        },
        {
          ArtikelID: "2059",
          MassOrBauseitsTag: "178 x 180 cm",
          Anzahl: 1,
        },
        {
          ArtikelID: "3297_preisaufschlag",
          MassOrBauseitsTag: "178 x 180 cm",
          Anzahl: 1,
        },
        {
          ArtikelID: "2323",
          MassOrBauseitsTag: "178 x 180 cm",
          Anzahl: 1,
        },
        {
          ArtikelID: "1251",
          MassOrBauseitsTag: "178 x 180 cm",
          Anzahl: 1,
        },
        {
          ArtikelID: "2550",
          MassOrBauseitsTag: "178 x 180 cm",
          Anzahl: 1,
        },
      ],
    ],
    agt.baugruppen
  );
};

export const testStücklisteDekorprofiladapterFertigungBauseitsMixed: Test = async () => {
  // Fehlende Artikelrelationen für Dekor_Adapter in Metadaten
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [16]);
  agt.update3d();
  const s = agt.segmente[0];
  const element = agt.createElementFromJson({
    form: "Rechteck",
    füllungAuswahlwert: "SYSTEM WPC CLASSIC Mandel",
    abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
    profilAuswahlwert: "Dekor Puls Edelstahl/hoch",
    profilPosition: 11,
    profilleisteAuswahlwert: "Dekor_Adapter_silber",
    showProfil: true,
  });
  s.getEmpties()[0].fillWithElements(element);
  agt.update3d();
  [0, 2, 4, 6]
    .map((i) => s.getElemente()[i])
    .forEach((e) =>
      e.setJsonPartial({
        form: "Einzeltor",
      })
    );
  [4, 5, 6, 7]
    .map((i) => s.getElemente()[i])
    .forEach((e) =>
      e.setJsonPartial({
        profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
      })
    );
  agt.update3d();
  assertEqualsBestellliste(
    [
      {
        ArtikelID: "1251",
        Anzahl: 4,
      },
      {
        ArtikelID: "1398",
        Anzahl: 1,
      },
      {
        ArtikelID: "2059",
        Anzahl: 4,
      },
      {
        ArtikelID: "2142",
        Anzahl: 3,
      },
      {
        ArtikelID: "2148",
        Anzahl: 4,
      },
      {
        ArtikelID: "2272",
        Anzahl: 1,
      },
      {
        ArtikelID: "2273",
        Anzahl: 1,
      },
      {
        ArtikelID: "2314",
        Anzahl: 1,
      },
      {
        ArtikelID: "2323",
        Anzahl: 2,
      },
      {
        ArtikelID: "2324",
        Anzahl: 2,
      },
      {
        ArtikelID: "2341",
        Anzahl: 1,
      },
      {
        ArtikelID: "2499_wpc_classic_xl",
        Anzahl: 4,
        Mass: "178 x 180 cm",
      },
      {
        ArtikelID: "2550",
        Anzahl: 4,
      },
      {
        ArtikelID: "2777",
        Anzahl: 7,
      },
      {
        ArtikelID: "3297",
        Anzahl: 4,
      },
      {
        ArtikelID: "3297_preisaufschlag",
        Anzahl: 2,
      },
      {
        ArtikelID: "3297_preisaufschlag",
        Anzahl: 2,
      },
    ],
    agt.bestellliste
  );
  assertEqualsBaugruppen(
    [
      [
        {
          ArtikelID: "2142",
          MassOrBauseitsTag: "",
          Anzahl: 4,
        },
        {
          ArtikelID: "3297",
          MassOrBauseitsTag: "",
          Anzahl: 4,
        },
        {
          ArtikelID: "2777",
          MassOrBauseitsTag: "",
          Anzahl: 7,
        },
      ],
      [
        {
          ArtikelID: "2341",
          MassOrBauseitsTag: "",
          Anzahl: 1,
        },
        {
          ArtikelID: "2314",
          MassOrBauseitsTag: "",
          Anzahl: 1,
        },
        {
          ArtikelID: "1398",
          MassOrBauseitsTag: "",
          Anzahl: 1,
        },
      ],
      [
        {
          ArtikelID: "2499_wpc_classic_xl",
          MassOrBauseitsTag: "178 x 180 cm",
          Anzahl: 2,
        },
        {
          ArtikelID: "2059",
          MassOrBauseitsTag: "178 x 180 cm",
          Anzahl: 2,
        },
        {
          ArtikelID: "3297_preisaufschlag",
          MassOrBauseitsTag: "178 x 180 cm",
          Anzahl: 2,
        },
        {
          ArtikelID: "2323",
          MassOrBauseitsTag: "178 x 180 cm",
          Anzahl: 2,
        },
        {
          ArtikelID: "1251",
          MassOrBauseitsTag: "178 x 180 cm",
          Anzahl: 2,
        },
        {
          ArtikelID: "2550",
          MassOrBauseitsTag: "178 x 180 cm",
          Anzahl: 2,
        },
      ],
      [
        {
          ArtikelID: "2499_wpc_classic_xl",
          MassOrBauseitsTag: "178 x 180 cm",
          Anzahl: 2,
        },
        {
          ArtikelID: "2059",
          MassOrBauseitsTag: "178 x 180 cm",
          Anzahl: 2,
        },
        {
          ArtikelID: "3297_preisaufschlag",
          MassOrBauseitsTag: "178 x 180 cm",
          Anzahl: 2,
        },
        {
          ArtikelID: "2324",
          MassOrBauseitsTag: "178 x 180 cm",
          Anzahl: 2,
        },
        {
          ArtikelID: "1251",
          MassOrBauseitsTag: "178 x 180 cm",
          Anzahl: 2,
        },
        {
          ArtikelID: "2550",
          MassOrBauseitsTag: "178 x 180 cm",
          Anzahl: 2,
        },
      ],
    ],
    agt.baugruppen
  );
};

export const testStücklisteDekorprofiladapterZuordnung: Test = async () => {
  // Fehlende Artikelrelationen für Dekor_Adapter in Metadaten
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [4]);
  agt.update3d();
  const s = agt.segmente[0];
  const element = agt.createElementFromJson({
    füllungAuswahlwert: "SYSTEM WPC CLASSIC Mandel",
  });
  s.getEmpties()[0].fillWithElements(element);
  agt.update3d();
  s.getElemente()[0].setJsonPartial({
    abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
    profilAuswahlwert: "Dekor Puls Edelstahl/hoch",
    profilPosition: 11,
    profilleisteAuswahlwert: "Dekor_Adapter_silber",
    showProfil: true,
  });
  s.getElemente()[1].setJsonPartial({
    abschlussleisteAuswahlwert: "Abschlussleisten Weiss",
    profilAuswahlwert: "Dekor Quattro Anthrazit/flach",
    profilPosition: 4,
    profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
    showProfil: true,
  });
  agt.update3d();
  assertEqualsBestellliste(
    [
      {
        ArtikelID: "1398",
        Anzahl: 1,
      },
      {
        ArtikelID: "2142",
        Anzahl: 2,
      },
      {
        ArtikelID: "2314",
        Anzahl: 3,
      },
      {
        ArtikelID: "2324",
        Anzahl: 1,
      },
      {
        ArtikelID: "2341",
        Anzahl: 3,
      },
      {
        ArtikelID: "3294",
        Anzahl: 1,
      },
      {
        ArtikelID: "3297",
        Anzahl: 1,
      },
      {
        ArtikelID: "3936",
        Anzahl: 1,
      },
      {
        ArtikelID: "3944",
        Anzahl: 1,
      },
    ],
    agt.bestellliste
  );
  assertEqualsBaugruppen(
    [
      [
        {
          ArtikelID: "2142",
          MassOrBauseitsTag: "",
          Anzahl: 1,
        },
        {
          ArtikelID: "3297",
          MassOrBauseitsTag: "",
          Anzahl: 1,
        },
      ],
      [
        {
          ArtikelID: "2142",
          MassOrBauseitsTag: "",
          Anzahl: 1,
        },
        {
          ArtikelID: "3294",
          MassOrBauseitsTag: "",
          Anzahl: 1,
        },
        {
          ArtikelID: "2324",
          MassOrBauseitsTag: "",
          Anzahl: 1,
        },
        {
          ArtikelID: "3936",
          MassOrBauseitsTag: "",
          Anzahl: 1,
        },
        {
          ArtikelID: "3944",
          MassOrBauseitsTag: "",
          Anzahl: 1,
        },
      ],
      [
        {
          ArtikelID: "2341",
          MassOrBauseitsTag: "",
          Anzahl: 3,
        },
        {
          ArtikelID: "2314",
          MassOrBauseitsTag: "",
          Anzahl: 3,
        },
        {
          ArtikelID: "1398",
          MassOrBauseitsTag: "",
          Anzahl: 1,
        },
      ],
    ],
    agt.baugruppen
  );
};

export const testStücklisteNichtStandardMaßFertigung: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [3]);
  agt.update3d();
  agt.fillIndividuellSegmentsWithElements();
  agt.update3d();
  return;
  const s = agt.segmente[0];
  const füllungAuswahlwert = APP.richMetadata.findAuswahlwert("Keramik Eiche");
  APP.arrangement.setSelectedObjects(s.getElemente());
  agt.changeSelectedZaunElemente({
    füllungAuswahlwert,
  });
  agt.update3d();
  assertEqualsBestellliste(
    [
      {
        ArtikelID: "2918",
        Anzahl: 1,
      },
      {
        ArtikelID: "2922",
        Anzahl: 1,
        Mass: "113 x 180 cm",
      },
      {
        ArtikelID: "2341",
        Anzahl: 3,
      },
      {
        ArtikelID: "2314",
        Anzahl: 3,
      },
      {
        ArtikelID: "1398",
        Anzahl: 1,
      },
    ],
    agt.bestellliste
  );
  assertEqualsBaugruppen(
    [
      [
        {
          ArtikelID: "2918",
          MassOrBauseitsTag: "",
          Anzahl: 1,
        },
      ],
      [
        {
          ArtikelID: "2922",
          MassOrBauseitsTag: "113 x 180 cm",
          Anzahl: 1,
        },
      ],
      [
        {
          ArtikelID: "2341",
          MassOrBauseitsTag: "",
          Anzahl: 3,
        },
        {
          ArtikelID: "2314",
          MassOrBauseitsTag: "",
          Anzahl: 3,
        },
        {
          ArtikelID: "1398",
          MassOrBauseitsTag: "",
          Anzahl: 1,
        },
      ],
    ],
    agt.baugruppen
  );
};

export const testStücklisteRhombusDekorprofile: Test = async () => {
  // Fehlende Artikelrelationen in Metadaten
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [12]);
  agt.update3d();
  const s = agt.segmente[0];
  const element = agt.createElementFromJson({
    füllungAuswahlwert: "SYSTEM Rhombus Weiß",
    profilAuswahlwert: "SYSTEM Rhombus Anthrazit Akzentfarbe",
    profilleisteAuswahlwert: "Dekor_Adapter_Rhombus_anthrazit",
    profilPosition: 23,
    showProfil: true,
  });
  assert.equals("SYSTEM Rhombus Weiß", element.füllungAuswahlwert.Key);
  s.getEmpties()[0].fillWithElements(element);
  agt.update3d();
  assertEqualsBestellliste(
    [
      {
        ArtikelID: "1398",
        Anzahl: 1,
      },
      {
        ArtikelID: "2314",
        Anzahl: 7,
      },
      {
        ArtikelID: "2341",
        Anzahl: 7,
      },
      {
        ArtikelID: "2951",
        Anzahl: 6,
      },
      {
        ArtikelID: "2962",
        Anzahl: 6,
      },
    ],
    agt.bestellliste
  );
  assertEqualsBaugruppen(
    [
      [
        {
          ArtikelID: "2951",
          MassOrBauseitsTag: "bauseits",
          Anzahl: 6,
        },
        {
          ArtikelID: "2962",
          MassOrBauseitsTag: "bauseits",
          Anzahl: 6,
        },
      ],
      [
        {
          ArtikelID: "2341",
          MassOrBauseitsTag: "",
          Anzahl: 7,
        },
        {
          ArtikelID: "2314",
          MassOrBauseitsTag: "",
          Anzahl: 7,
        },
        {
          ArtikelID: "1398",
          MassOrBauseitsTag: "",
          Anzahl: 1,
        },
      ],
    ],
    agt.baugruppen
  );
};

export const testStücklisteRhombus60: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [2]);
  agt.update3d();
  const s = agt.segmente[0];
  const element = agt.createElementFromJson({
    breite: 0.4,
    höhe: 1.8,
    füllungAuswahlwert: "SYSTEM Rhombus Weiß",
    form: "Rechteck",
    detailSerie: "SYSTEM RHOMBUS",
  });
  s.addPart(element);
  assert.equals("SYSTEM Rhombus Weiß", element.füllungAuswahlwert.Key);
  agt.update3d();
  assertEqualsBestellliste(
    [
      {
        ArtikelID: "2952",
        Anzahl: 1,
      },
      {
        ArtikelID: "2341",
        Anzahl: 2,
      },
      {
        ArtikelID: "2314",
        Anzahl: 2,
      },
      {
        ArtikelID: "1398",
        Anzahl: 1,
      },
    ],
    agt.bestellliste
  );
  assertEqualsBaugruppen(
    [
      [
        {
          ArtikelID: "2952",
          MassOrBauseitsTag: "bauseits",
          Anzahl: 1,
        },
      ],
      [
        {
          ArtikelID: "2341",
          MassOrBauseitsTag: "",
          Anzahl: 2,
        },
        {
          ArtikelID: "2314",
          MassOrBauseitsTag: "",
          Anzahl: 2,
        },
        {
          ArtikelID: "1398",
          MassOrBauseitsTag: "",
          Anzahl: 1,
        },
      ],
    ],
    agt.baugruppen
  );
};

export const testStücklisteRhombus180: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [2]);
  agt.update3d();
  const s = agt.segmente[0];
  const element = agt.createElementFromJson({
    breite: 1,
    höhe: 1.8,
    füllungAuswahlwert: "SYSTEM Rhombus Weiß",
    form: "Rechteck",
    detailSerie: "SYSTEM RHOMBUS",
  });
  s.addPart(element);
  assert.equals("SYSTEM Rhombus Weiß", element.füllungAuswahlwert.Key);
  agt.update3d();
  assertEqualsBestellliste(
    [
      {
        ArtikelID: "2951",
        Anzahl: 1,
      },
      {
        ArtikelID: "2341",
        Anzahl: 2,
      },
      {
        ArtikelID: "2314",
        Anzahl: 2,
      },
      {
        ArtikelID: "1398",
        Anzahl: 1,
      },
    ],
    agt.bestellliste
  );
  assertEqualsBaugruppen(
    [
      [
        {
          ArtikelID: "2951",
          MassOrBauseitsTag: "bauseits",
          Anzahl: 1,
        },
      ],
      [
        {
          ArtikelID: "2341",
          MassOrBauseitsTag: "",
          Anzahl: 2,
        },
        {
          ArtikelID: "2314",
          MassOrBauseitsTag: "",
          Anzahl: 2,
        },
        {
          ArtikelID: "1398",
          MassOrBauseitsTag: "",
          Anzahl: 1,
        },
      ],
    ],
    agt.baugruppen
  );
};

export const testStücklisteRhombus90: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [4]);
  agt.update3d();
  const s = agt.segmente[0];
  const element = agt.createElementFromJson({
    breite: 1.8,
    höhe: 0.9,
    füllungAuswahlwert: "SYSTEM Rhombus Weiß",
    form: "Rechteck",
    detailSerie: "SYSTEM RHOMBUS",
  });
  s.getEmpties()[0].fillWithElements(element);
  assert.equals("SYSTEM Rhombus Weiß", element.füllungAuswahlwert.Key);
  agt.update3d();
  assertEqualsBestellliste(
    [
      {
        ArtikelID: "2953",
        Anzahl: 2,
      },
      {
        ArtikelID: "2340",
        Anzahl: 3,
      },
      {
        ArtikelID: "2314",
        Anzahl: 3,
      },
      {
        ArtikelID: "1398",
        Anzahl: 1,
      },
    ],
    agt.bestellliste
  );
  assertEqualsBaugruppen(
    [
      [
        {
          ArtikelID: "2953",
          MassOrBauseitsTag: "",
          Anzahl: 2,
        },
      ],
      [
        {
          ArtikelID: "2340",
          MassOrBauseitsTag: "",
          Anzahl: 3,
        },
        {
          ArtikelID: "2314",
          MassOrBauseitsTag: "",
          Anzahl: 3,
        },
        {
          ArtikelID: "1398",
          MassOrBauseitsTag: "",
          Anzahl: 1,
        },
      ],
    ],
    agt.baugruppen
  );
};

export const testStücklisteRhombusDekorprofiladapterTrigon: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  const breite = 12;
  agt.grundriss.setStandardForm("Strecke", [breite]);
  agt.update3d();
  const s = agt.segmente[0];
  const element = agt.createElementFromJson({
    füllungAuswahlwert: "SYSTEM Rhombus Weiß",
    showProfil: true,
    profilAuswahlwert: "Dekor Trigon Anthrazit/hoch",
    profilPosition: 26,
    profilleisteAuswahlwert: "Dekor_Adapter_Rhombus_anthrazit",
    profilzylinderAuswahlwert: "Profilzylinder_mit",
  });
  assert.equals("SYSTEM Rhombus Weiß", element.füllungAuswahlwert.Key);
  s.getEmpties()[0].fillWithElements(element);
  agt.update3d();
  assertEqualsBestellliste(
    [
      {
        ArtikelID: "2951",
        Anzahl: 5,
      },
      {
        ArtikelID: "3293",
        Anzahl: 6,
      },
      {
        ArtikelID: "3892",
        Anzahl: 6,
      },
      {
        ArtikelID: "2649",
        Anzahl: 1,
      },
      {
        ArtikelID: "2341",
        Anzahl: 7,
      },
      {
        ArtikelID: "2314",
        Anzahl: 7,
      },
      {
        ArtikelID: "1398",
        Anzahl: 1,
      },
    ],
    agt.bestellliste
  );
  assertEqualsBaugruppen(
    [
      [
        {
          ArtikelID: "2951",
          MassOrBauseitsTag: "bauseits",
          Anzahl: 6,
        },
        {
          ArtikelID: "3293",
          MassOrBauseitsTag: "bauseits",
          Anzahl: 6,
        },
        {
          ArtikelID: "3892",
          MassOrBauseitsTag: "bauseits",
          Anzahl: 6,
        },
      ],
      [
        {
          ArtikelID: "2341",
          MassOrBauseitsTag: "",
          Anzahl: 7,
        },
        {
          ArtikelID: "2314",
          MassOrBauseitsTag: "",
          Anzahl: 7,
        },
        {
          ArtikelID: "1398",
          MassOrBauseitsTag: "",
          Anzahl: 1,
        },
      ],
    ],
    agt.baugruppen
  );
};

export const testStücklisteSortierungDekorprofiladapterBeiToren: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  const breite = 8;
  agt.grundriss.setStandardForm("Strecke", [breite]);
  agt.update3d();
  const s = agt.segmente[0];
  // form:"Doppeltor"
  const common = {
    detailSerie: "SYSTEM HOLZ",
    füllungAuswahlwert: "SYSTEM HOLZ Thermokiefer",
    füllungsseiteAuswahlwert: "Füllungsseite_B",
    profilAuswahlwert: "Dekor Omega Anthrazit/flach",
    profilPosition: 10,
    profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
    rahmenAuswahlwert: "Tor_Rahmen_Anthrazit",
    showProfil: true,
  };
  s.addPart(
    agt.createElementFromJson({
      form: "Einzeltor",
      ...common,
    })
  );
  s.addPart(
    agt.createElementFromJson({
      form: "Rechteck",
      ...common,
    })
  );
  s.addPart(
    agt.createElementFromJson({
      form: "Doppeltor",
      ...common,
    })
  );
  agt.update3d();
  assertEqualsBestellliste(
    [
      {
        ArtikelID: "3780",
        Anzahl: 1,
      },
      {
        ArtikelID: "2433",
        Anzahl: 1,
      },
      {
        ArtikelID: "2324",
        Anzahl: 1,
      },
      {
        ArtikelID: "2499_thermoholz",
        Anzahl: 1,
        Mass: "178 x 180 cm",
      },
      {
        ArtikelID: "2433_preisaufschlag",
        Anzahl: 1,
      },
      {
        ArtikelID: "2324",
        Anzahl: 1,
      },
      {
        ArtikelID: "2059",
        Anzahl: 1,
      },
      {
        ArtikelID: "1251",
        Anzahl: 1,
      },
      {
        ArtikelID: "2550",
        Anzahl: 1,
      },
      {
        ArtikelID: "2036_thermoholz",
        Anzahl: 1,
        Mass: "177 x 180 cm",
      },
      {
        ArtikelID: "2433_preisaufschlag",
        Anzahl: 2,
      },
      {
        ArtikelID: "2324",
        Anzahl: 2,
      },
      {
        ArtikelID: "2018",
        Anzahl: 1,
      },
      {
        ArtikelID: "1251",
        Anzahl: 1,
      },
      {
        ArtikelID: "2550",
        Anzahl: 1,
      },
      {
        ArtikelID: "2777",
        Anzahl: 2,
      },
      {
        ArtikelID: "287",
        Anzahl: 1,
      },
    ],
    agt.bestellliste
  );
};

export const testZuschnittsoptimierung40Plus120: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  const breite = 12;
  agt.grundriss.setStandardForm("Strecke", [breite]);
  agt.update3d();
  const s = agt.segmente[0];
  s.addPart(
    agt.createElementFromJson({
      füllungAuswahlwert: "SYSTEM Rhombus Anthrazit",
      breite: 0.4,
      höhe: 1.8,
    })
  );
  s.addPart(
    agt.createElementFromJson({
      füllungAuswahlwert: "SYSTEM Rhombus Anthrazit",
      breite: 1.2,
      höhe: 1.8,
    })
  );
  agt.update3d();
  assertEqualsBestellliste(
    [
      {
        ArtikelID: "2647",
        Anzahl: 1,
      },
      {
        ArtikelID: "2649",
        Anzahl: 1,
      },
      {
        ArtikelID: "2341",
        Anzahl: 3,
      },
      {
        ArtikelID: "2314",
        Anzahl: 3,
      },
      {
        ArtikelID: "1398",
        Anzahl: 1,
      },
    ],
    agt.bestellliste
  );
};

export const testElementhalterWechselNeo: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  const breite = 8;
  agt.grundriss.setStandardForm("Strecke", [breite]);
  agt.inspiration = APP.richMetadata.findAuswahlwert("Inspiartion NEO DESIGN Grau")?.Inspiration[0];
  agt.update3d();
  const s = agt.segmente[0];
  s.addPart(
    agt.createElementFromJson({
      breite: 0.89,
      höhe: 1.79,
      füllungAuswahlwert: "NEO DESIGN Grau",
      aufsatzleisteAuswahlwert: "Aufsatzleiste Alu 1781",
    })
  );
  agt.update3d();
  assert.equals("2096 Elementhalter", agt.getPfosten()[0].elementhalterAuswahlwert.Key);
  agt.changeSelectedPfosten({
    elementhalterAuswahlwert: APP.richMetadata.findAuswahlwert("2166 Elementhalter"),
  });
  assert.equals("2166 Elementhalter", agt.getPfosten()[0].elementhalterAuswahlwert.Key);
  assertEqualsBestellliste(
    [
      {
        ArtikelID: "1348",
        Anzahl: 1,
      },
      {
        ArtikelID: "1590",
        Anzahl: 2,
      },
      {
        ArtikelID: "1781",
        Anzahl: 1,
      },
      {
        ArtikelID: "2166",
        Anzahl: 1,
      },
    ],
    agt.bestellliste
  );
};

export const testSmartControlSet: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  const breite = 2;
  agt.grundriss.setStandardForm("Strecke", [breite]);
  agt.update3d();
  const s = agt.segmente[0];
  s.getEmpties()[0].fillWithElements(agt.createDefaultElement());
  agt.update3d();
  const element = agt.getElemente()[0];
  element.setShowProfil(true);
  element.addLichtleiste();
  agt.update3d();
  assertEqualsBestellliste(
    [
      {
        ArtikelID: "1398",
        Anzahl: 1,
      },
      {
        ArtikelID: "2143",
        Anzahl: 1,
      },
      {
        ArtikelID: "2314",
        Anzahl: 2,
      },
      {
        ArtikelID: "2341",
        Anzahl: 2,
      },
      {
        ArtikelID: "3819",
        Anzahl: 1,
      },
      {
        ArtikelID: "3820",
        Anzahl: 1,
      },
      {
        ArtikelID: "3821",
        Anzahl: 1,
      },
      {
        ArtikelID: "3834",
        Anzahl: 1,
      },
    ],
    agt.bestellliste
  );
  agt.lichtleistenZubehörAnzahl["3834 SYSTEM Licht Smart Control Set"] = 0;
  agt.update3d();
  assertEqualsBestellliste(
    [
      {
        ArtikelID: "1398",
        Anzahl: 1,
      },
      {
        ArtikelID: "2143",
        Anzahl: 1,
      },
      {
        ArtikelID: "2314",
        Anzahl: 2,
      },
      {
        ArtikelID: "2341",
        Anzahl: 2,
      },
      {
        ArtikelID: "3819",
        Anzahl: 1,
      },
      {
        ArtikelID: "3821",
        Anzahl: 1,
      },
      {
        ArtikelID: "3826",
        Anzahl: 1,
      },
    ],
    agt.bestellliste
  );
};

export const testTorpfostenLichtkappenZusammengezählt: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  const breite = 7;
  agt.grundriss.setStandardForm("Strecke", [breite]);
  agt.update3d();
  const s = agt.segmente[0];
  s.getEmpties()[0].fillWithElements(agt.createDefaultElement());
  agt.update3d();
  [0, 2].forEach((i) =>
    agt.getElemente()[i].change({
      massAuswahlwert: APP.richMetadata.findAuswahlwert("Einzeltor_Easy"),
    })
  );
  agt.update3d();
  agt
    .getTorpfosten()
    .forEach(
      (t) =>
        (t.pfostenkappeAuswahlwert = APP.richMetadata.findAuswahlwert(
          "3840 SYSTEM Licht Pfostenkappe Universal"
        ))
    );
  agt.update3d();
  assertEqualsBestellliste(
    [
      {
        ArtikelID: "1251",
        Anzahl: 2,
      },
      {
        ArtikelID: "2059",
        Anzahl: 2,
      },
      {
        ArtikelID: "2137",
        Anzahl: 2,
      },
      {
        ArtikelID: "2143",
        Anzahl: 1,
      },
      {
        ArtikelID: "2550",
        Anzahl: 2,
      },
      {
        ArtikelID: "2777",
        Anzahl: 2,
      },
      {
        ArtikelID: "3820",
        Anzahl: 1,
      },
      {
        ArtikelID: "3821",
        Anzahl: 1,
      },
      {
        ArtikelID: "3834",
        Anzahl: 1,
      },
      {
        ArtikelID: "3840",
        Anzahl: 4,
      },
    ],
    agt.bestellliste
  );
};

export const testStücklisteEinzeltorDINLinks: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [3]);
  agt.update3d();
  const s = agt.segmente[0];
  const tor = agt.createElementFromJson({
    anschlagAuswahlwert: "Anschlag_links",
    form: "Einzeltor",
    detailSerie: "SYSTEM WPC CLASSIC",
    füllungAuswahlwert: "SYSTEM WPC CLASSIC Anthrazit",
    öffnungAuswahlwert: "Öffnung_nach_innen",
    füllungsseiteAuswahlwert: "Füllungsseite_B",
    breite: 0.98,
    höhe: 1.8,
  });
  s.getEmpties()[0].fillWithElements(tor);
  agt.update3d();
  // Achtung! Erst nach dem 2. Update sind die UMProfile drin!
  agt.update3d();
  assertEqualsBestellliste(
    [
      {
        ArtikelID: "2137",
        Anzahl: 1,
      },
      {
        ArtikelID: "2059",
        Anzahl: 1,
      },
      {
        ArtikelID: "1251",
        Anzahl: 1,
      },
      {
        ArtikelID: "2550",
        Anzahl: 1,
      },
    ],
    agt.bestellliste
  );
};

export const testStücklisteEinzeltorDINRechts: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [3]);
  agt.update3d();
  const s = agt.segmente[0];
  const tor = agt.createElementFromJson({
    anschlagAuswahlwert: "Anschlag_rechts",
    form: "Einzeltor",
    detailSerie: "SYSTEM WPC CLASSIC",
    füllungAuswahlwert: "SYSTEM WPC CLASSIC Anthrazit",
    öffnungAuswahlwert: "Öffnung_nach_innen",
    füllungsseiteAuswahlwert: "Füllungsseite_B",
    breite: 0.98,
    höhe: 1.8,
  });
  s.getEmpties()[0].fillWithElements(tor);
  agt.update3d();
  // Achtung! Erst nach dem 2. Update sind die UMProfile drin!
  agt.update3d();
  assertEqualsBestellliste(
    [
      {
        ArtikelID: "2281",
        Anzahl: 1,
      },
      {
        ArtikelID: "2059",
        Anzahl: 1,
      },
      {
        ArtikelID: "1251",
        Anzahl: 1,
      },
      {
        ArtikelID: "2550",
        Anzahl: 1,
      },
    ],
    agt.bestellliste
  );
};

export const testStücklisteMassUndSondertore: Test = async () => {
  // Nach diesem Test tritt WebGL: CONTEXT_LOST_WEBGL: loseContext: context lost auf
  return IGNORED;
  const serienArtikelKombinationen = [
    {
      serie: "SYSTEM WPC CLASSIC",
      sollArtikel: [
        "2499_wpc_classic_xl",
        "2499_wpc_classic_xl",
        "2499_wpc_classic_xl",
        "2499_wpc_classic_xl",
        "2036",
        "2036",
        "2036",
        "2036",
        "2966_wpc",
        "2966_wpc",
        "3761_wpc",
        "3761_wpc",
        "2854_wpc_classic_xl",
        "2854_wpc_classic_xl",
        "3760_wpc",
        "3760_wpc",
        "4588",
        "4588",
        "4588",
        "4588",
      ],
      spezialprofilKategorien: {
        dekorprofil: ["Dekorprofile_Mass_Tore_15cm", "Dekorprofile_Mass_Tore_30cm"],
        akzentfarbe: ["Basisprofile_Mass_Tore_WPC_Classic_15cm"],
        designprofil: ["Designprofile_Steckzaun_Tore"],
      },
    },
    {
      serie: "SYSTEM WPC XL",
      sollArtikel: [
        "2499_wpc_classic_xl",
        "2499_wpc_classic_xl",
        "2499_wpc_classic_xl",
        "2499_wpc_classic_xl",
        "2036",
        "2036",
        "2036",
        "2036",
        "2966_wpc",
        "2966_wpc",
        "3761_wpc",
        "3761_wpc",
        "2854_wpc_classic_xl",
        "2854_wpc_classic_xl",
        "3760_wpc",
        "3760_wpc",
        "4588",
        "4588",
        "4588",
        "4588",
      ],
      spezialprofilKategorien: {
        dekorprofil: ["Dekorprofile_Mass_Tore_30cm"],
        akzentfarbe: ["Basisprofile_Mass_Tore_WPC_XL_30cm"],
        designprofil: ["Designprofile_Steckzaun_Tore"],
      },
    },
    {
      serie: "SYSTEM NEO WPC PLATINUM 15",
      sollArtikel: [
        "2499_wpc_platinum",
        "2499_wpc_platinum",
        "2499_wpc_platinum",
        "2499_wpc_platinum",
        "2036",
        "2036",
        "2036",
        "2036",
        "2966_wpc",
        "2966_wpc",
        "3761_wpc",
        "3761_wpc",
        "2854_wpc_platinum",
        "2854_wpc_platinum",
        "3760_wpc",
        "3760_wpc",
        "4588",
        "4588",
        "4588",
        "4588",
      ],
      spezialprofilKategorien: {
        dekorprofil: ["Dekorprofile_Mass_Tore_15cm", "Dekorprofile_Mass_Tore_30cm"],
        akzentfarbe: ["Basisprofile_Mass_Tore_NEO_WPC_15cm"],
        designprofil: ["Designprofile_Steckzaun_Tore"],
      },
    },
    {
      serie: "SYSTEM WPC PLATINUM",
      sollArtikel: [
        "2499_wpc_platinum",
        "2499_wpc_platinum",
        "2499_wpc_platinum",
        "2499_wpc_platinum",
        "2036",
        "2036",
        "2036",
        "2036",
        "2966_wpc",
        "2966_wpc",
        "3761_wpc",
        "3761_wpc",
        "2854_wpc_platinum",
        "2854_wpc_platinum",
        "3760_wpc",
        "3760_wpc",
        "4588",
        "4588",
        "4588",
        "4588",
      ],
      spezialprofilKategorien: {
        dekorprofil: ["Dekorprofile_Mass_Tore_15cm", "Dekorprofile_Mass_Tore_30cm"],
        akzentfarbe: ["Basisprofile_Mass_Tore_WPC_PLATINUM_15cm"],
        designprofil: ["Designprofile_Steckzaun_Tore"],
      },
    },
    {
      serie: "SYSTEM WPC PLATINUM XL",
      sollArtikel: [
        "2499_wpc_platinum",
        "2499_wpc_platinum",
        "2499_wpc_platinum",
        "2499_wpc_platinum",
        "2036",
        "2036",
        "2036",
        "2036",
        "2966_wpc",
        "2966_wpc",
        "3761_wpc",
        "3761_wpc",
        "2854_wpc_platinum",
        "2854_wpc_platinum",
        "3760_wpc",
        "3760_wpc",
        "4588",
        "4588",
        "4588",
        "4588",
      ],
      spezialprofilKategorien: {
        dekorprofil: ["Dekorprofile_Mass_Tore_30cm"],
        akzentfarbe: ["Basisprofile_Mass_Tore_WPC_PLATINUM_XL_30cm"],
        designprofil: ["Designprofile_Steckzaun_Tore"],
      },
    },
    {
      serie: "SYSTEM ALU PLUS 15",
      sollArtikel: [
        "2557_alu",
        "2557_alu",
        "2557_alu",
        "2557_alu",
        "2556_alu",
        "2556_alu",
        "2556_alu",
        "2556_alu",
        "2966_alu",
        "2966_alu",
        "3761_alu",
        "3761_alu",
        "2854_alu",
        "2854_alu",
        "3760_alu",
        "3760_alu",
        "4587",
        "4587",
        "4587",
        "4587",
      ],
      spezialprofilKategorien: {
        dekorprofil: ["Dekorprofile_Mass_Tore_15cm", "Dekorprofile_Mass_Tore_30cm"],
        akzentfarbe: ["Basisprofile_Mass_Tore_ALU_15cm"],
        designprofil: ["Designprofile_Steckzaun_Tore"],
      },
    },
    {
      serie: "SYSTEM ALU XL 30",
      sollArtikel: [
        "2557_alu",
        "2557_alu",
        "2557_alu",
        "2557_alu",
        "2556_alu",
        "2556_alu",
        "2556_alu",
        "2556_alu",
        "2966_alu",
        "2966_alu",
        "3761_alu",
        "3761_alu",
        "2854_alu",
        "2854_alu",
        "3760_alu",
        "3760_alu",
        "4587",
        "4587",
        "4587",
        "4587",
      ],
      spezialprofilKategorien: {
        dekorprofil: ["Dekorprofile_Mass_Tore_30cm"],
        akzentfarbe: ["Basisprofile_Mass_Tore_ALU_30cm"],
        designprofil: ["Designprofile_Steckzaun_Tore"],
      },
    },
  ];
  const torKombinationen = [
    {
      key: "Einzeltor auf Maß",
      spezialprofilTyp: "plain",
      form: "Einzeltor",
      eAntrieb: false,
      masse: [1.6, 1.8],
      Mass: "160 x 180 cm",
      standardRahmen: true,
    },
    {
      key: "Einzeltor auf Maß mit Akzentfarbe",
      spezialprofilTyp: "akzentfarbe",
      form: "Einzeltor",
      eAntrieb: false,
      masse: [1.6, 1.8],
      Mass: "160 x 180 cm",
      standardRahmen: true,
    },
    {
      key: "Einzeltor auf Maß mit Dekorprofil",
      spezialprofilTyp: "dekorprofil",
      form: "Einzeltor",
      eAntrieb: false,
      masse: [1.6, 1.8],
      Mass: "160 x 180 cm",
      standardRahmen: true,
    },
    {
      key: "Einzeltor auf Maß mit Designprofil",
      spezialprofilTyp: "designprofil",
      form: "Einzeltor",
      eAntrieb: false,
      masse: [1.6, 1.8],
      Mass: "160 x 180 cm",
      standardRahmen: true,
    },
    {
      key: "Doppeltor auf Maß",
      spezialprofilTyp: "plain",
      form: "Doppeltor",
      eAntrieb: false,
      masse: [1.5, 1.8],
      Mass: "149 x 180 cm",
      standardRahmen: true,
    },
    {
      key: "Doppeltor auf Maß mit Akzentfarbe",
      spezialprofilTyp: "akzentfarbe",
      form: "Doppeltor",
      eAntrieb: false,
      masse: [1.5, 1.8],
      Mass: "149 x 180 cm",
      standardRahmen: true,
    },
    {
      key: "Doppeltor auf Maß mit Designprofil",
      spezialprofilTyp: "designprofil",
      form: "Doppeltor",
      eAntrieb: false,
      masse: [1.5, 1.8],
      Mass: "149 x 180 cm",
      standardRahmen: true,
    },
    {
      key: "Doppeltor auf Maß mit Dekorprofil",
      spezialprofilTyp: "dekorprofil",
      form: "Doppeltor",
      eAntrieb: false,
      masse: [1.5, 1.8],
      Mass: "149 x 180 cm",
      standardRahmen: true,
    },
    {
      key: "Sondertor 98x180",
      spezialprofilTyp: "plain",
      form: "Einzeltor",
      eAntrieb: false,
      masse: [0.98, 1.8],
      standardRahmen: false,
    },
    {
      key: "Sondertor 98x180 mit Akzentfarbe",
      spezialprofilTyp: "akzentfarbe",
      form: "Einzeltor",
      eAntrieb: false,
      masse: [0.98, 1.8],
      standardRahmen: true,
    },
    {
      key: "ET Dekor 98x180 mit Dekorprofil",
      spezialprofilTyp: "dekorprofil",
      form: "Einzeltor",
      eAntrieb: false,
      masse: [0.98, 1.8],
      standardRahmen: true,
    },
    {
      key: "ET Dekor 98x180 mit Designprofil",
      spezialprofilTyp: "designprofil",
      form: "Einzeltor",
      eAntrieb: false,
      masse: [0.98, 1.8],
      standardRahmen: true,
    },
    {
      key: "Sondertor 98x90",
      spezialprofilTyp: "plain",
      form: "Einzeltor",
      eAntrieb: false,
      masse: [0.98, 0.9],
      standardRahmen: false,
    },
    {
      key: "Sondertor 98x90 mit Akzentfarbe",
      spezialprofilTyp: "akzentfarbe",
      form: "Einzeltor",
      eAntrieb: false,
      masse: [0.98, 0.9],
      standardRahmen: true,
    },
    {
      key: "ET Dekor 98x90 mit Dekorprofil",
      spezialprofilTyp: "dekorprofil",
      form: "Einzeltor",
      eAntrieb: false,
      masse: [0.98, 0.9],
      standardRahmen: true,
    },
    {
      key: "ET Dekor 98x90 mit Designprofil",
      spezialprofilTyp: "designprofil",
      form: "Einzeltor",
      eAntrieb: false,
      masse: [0.98, 0.9],
      standardRahmen: true,
    },
    {
      key: "Doppeltor mit E-Antrieb",
      spezialprofilTyp: "plain",
      form: "Doppeltor",
      eAntrieb: true,
      masse: [1.8, 1.8],
      Mass: "360 x 180 cm",
      standardRahmen: true,
    },
    {
      key: "Doppeltor mit E-Antrieb und Akzentfarbe",
      spezialprofilTyp: "akzentfarbe",
      form: "Doppeltor",
      eAntrieb: true,
      masse: [1.8, 1.8],
      Mass: "360 x 180 cm",
      standardRahmen: true,
    },
    {
      key: "Doppeltor mit E-Antrieb und Dekorprofil",
      spezialprofilTyp: "dekorprofil",
      form: "Doppeltor",
      eAntrieb: true,
      masse: [1.8, 1.8],
      Mass: "360 x 180 cm",
      standardRahmen: true,
    },
    {
      key: "Doppeltor mit E-Antrieb und Designprofil",
      spezialprofilTyp: "designprofil",
      form: "Doppeltor",
      eAntrieb: true,
      masse: [1.8, 1.8],
      Mass: "360 x 180 cm",
      standardRahmen: true,
    },
  ];

  const senkrechtSuffix = ["", "_Senkrecht"];

  const getFüllungenForDetailSerie = (serie: string) => {
    const detailSerieAuswahlwert = APP.richMetadata.findAuswahlwert(serie);
    return detailSerieAuswahlwert?.DetailSerie[0]?.Inspiration.map((i) => i.Füllung);
  };

  for (let i = 0; i < serienArtikelKombinationen.length; i++) {
    const { serie, sollArtikel, spezialprofilKategorien } = serienArtikelKombinationen[i];
    const füllungen = getFüllungenForDetailSerie(serie);
    console.log(
      `%cDetailSerie: ${serie}  %cFüllungen: %c${füllungen.length}`,
      "color:#000;background:#edea0e;padding:2px 6px;border-radius:4px;font-weight:bold;",
      "color:#fff;background:#1f1f1f;padding:2px 6px;border-radius:4px;",
      "color:#000;background:#edea0e;padding:2px 6px;border-radius:4px;"
    );
    for (let j = 0; j < füllungen.length; j++) {
      const füllungAuswahlwertKey = füllungen[j].Key;
      for (let k = 0; k < torKombinationen.length; k++) {
        const { key, spezialprofilTyp, form, eAntrieb, masse, Mass, standardRahmen } =
          torKombinationen[k];
        const spezialprofile =
          spezialprofilTyp == "plain"
            ? [null]
            : spezialprofilKategorien[spezialprofilTyp]
                .map(
                  (kategorie: string) =>
                    APP.richMetadata.findAuswahlwert(kategorie)?.Profilkategorie[0]?.Profile || []
                )
                .flat()
                .filter((p: MObjekt) => p?.Auswahlwert?.Key !== füllungAuswahlwertKey);
        for (let l = 0; l < senkrechtSuffix.length; l++) {
          const suffix = senkrechtSuffix[l];
          for (let m = 0; m < spezialprofile.length; m++) {
            const spezialprofil = spezialprofile[m]?.Auswahlwert;
            await sleep(1);
            if (
              !(await subTestContext(
                `${key} | Füllung: ${füllungAuswahlwertKey} | Spezialprofil: ${spezialprofil?.Key} | TorRahmen: ${standardRahmen ? "Anthrazit" : "Weiß"} | Profilausrichtung: ${suffix ? "Waagerecht" : "Senkrecht"}`,
                async () => {
                  resetArrangement();
                  const agt = APP.arrangement;
                  agt.grundriss.setStandardForm("Strecke", [6]);
                  agt.update3d();
                  const s = agt.segmente[0];
                  const sonderRahmen = ["Silber", "Weiß"].includes(füllungen[j].Bezeichnung)
                    ? "Tor_Rahmen_Anthrazit"
                    : "Tor_Rahmen_Weiss";
                  const elementObj = {
                    detailSerie: serie,
                    form: form.concat(suffix),
                    füllungAuswahlwert: füllungAuswahlwertKey,
                    profilAuswahlwert: spezialprofil?.Key,
                    rahmenAuswahlwert: standardRahmen ? "Tor_Rahmen_Anthrazit" : sonderRahmen,
                    eAntriebAuswahlwert: eAntrieb ? "E_Antrieb_mit" : "E_Antrieb_ohne",
                    breite: masse[0],
                    höhe: masse[1],
                    profilPosition: 2,
                    showProfil: spezialprofilTyp == "plain" ? false : true,
                  };
                  console.log(
                    `%c${key}  %cFüllung: %c${füllungAuswahlwertKey} %c| Profilausrichtung: %c${suffix ? "Waagerecht" : "Senkrecht"} %c| Rahmen: %c${standardRahmen ? "Tor_Rahmen_Anthrazit" : sonderRahmen} %c| ArtikelID: %c${sollArtikel[k]}`,
                    "color:#fff;background:#2b6;padding:2px 6px;border-radius:4px;font-weight:bold;",
                    "color:#fff;background:#1f1f1f;padding:2px 6px;border-radius:4px;",
                    "color:#fff;background:#2b6;padding:2px 6px;border-radius:4px",
                    "color:#fff;background:#1f1f1f;padding:2px 6px;border-radius:4px;",
                    "color:#fff;background:#2b6;padding:2px 6px;border-radius:4px",
                    "color:#fff;background:#1f1f1f;padding:2px 6px;border-radius:4px;",
                    "color:#fff;background:#2b6;padding:2px 6px;border-radius:4px;",
                    "color:#fff;background:#1f1f1f;padding:2px 6px;border-radius:4px;",
                    "color:#fff;background:#2b6;padding:2px 6px;border-radius:4px;"
                  );
                  const element = agt.createElementFromJson(elementObj);
                  s.getEmpties()[0].fillWithElements(element);
                  agt.update3d();
                  assertBestelllisteContains(
                    { ArtikelID: sollArtikel[k], Anzahl: 1, Mass },
                    agt.bestellliste
                  );
                  return true;
                }
              ))
            )
              break;
          }
        }
      }
    }
  }
};
